import { render, staticRenderFns } from "./jtcy.vue?vue&type=template&id=624d98ba&scoped=true&"
import script from "./jtcy.vue?vue&type=script&lang=js&"
export * from "./jtcy.vue?vue&type=script&lang=js&"
import style0 from "./jtcy.vue?vue&type=style&index=0&id=624d98ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624d98ba",
  null
  
)

export default component.exports